import React, { useContext, useEffect, useState } from 'react'
import { ScientificDayInterface, ShowScientificDayContext } from './types';
import { hostName } from '../../requestMethods';
import { FaChevronCircleLeft, FaChevronCircleRight, FaTrash } from 'react-icons/fa';
import { InputImages } from '../../HtmlComponents/InputImages';
import { AddScientificDayPhotoApi } from '../../redux/scientificday/scientificDayApiCalls';
import { useDispatch } from 'react-redux';
import { Timeout } from '../../functions/functions';
import ShowErrorMsg from '../../HtmlComponents/ShowErrorMsg';

interface props {
  sDay: ScientificDayInterface
}

const ToggleImages:React.FC<props> = ({ sDay }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % sDay.images.length);
  };

  const goToPrevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + sDay.images.length) % sDay.images.length);
  };

  const { setShowSuccessMsg, showDeleteScientificDayPhotoModal, setShowDeleteScientificDayPhotoModal, setSelectedPhoto, setSelectedScientificDay } =  useContext(ShowScientificDayContext)

  const [images, setImages] = useState<File[] | any>(null)

  const dispatch: any = useDispatch()
  const [errors, setErrors] = useState([])

  useEffect(() => {
    if(images) {
      const handleSubmit = async () => {
        const formData: any = new FormData()
  
        for (let i = 0; i < images.length; i++) {
          formData.append("images", images[i]);
        }

        const response: any = await dispatch(AddScientificDayPhotoApi(sDay._id, formData))
        if(response === true) {
          setImages(null)
          setShowSuccessMsg(true)
          setTimeout(() => setShowSuccessMsg(false), Timeout)
        } else {
          setErrors(response)
        }
      }
      handleSubmit()
      setImages(null)
    }
  }, [images, sDay, dispatch, setShowSuccessMsg])

  const toggleDeletePhotoModal = (img: string) => {
    setShowDeleteScientificDayPhotoModal(!showDeleteScientificDayPhotoModal)
    setSelectedPhoto(img)
    setSelectedScientificDay(sDay)
  }

  const [currentImage, setCurrentImage] = useState<any>()

  useEffect(() => {
    sDay.images[currentIndex] ? setCurrentImage(sDay.images[currentIndex]) : setCurrentImage(sDay.images[0])
  }, [sDay, currentIndex])

  return (
    <div>
    {currentImage && 
      <>
        <ShowErrorMsg errors={errors} setErrors={setErrors} />
        <div className="flex justify-between items-center">
          <FaChevronCircleLeft style={{ fontSize: "30px" }} className="text-main" onClick={goToPrevSlide}/>
          <section className='relative'>
            <img className='w-80 h-80' src={hostName + "imgs/ScientificDay/" + currentImage} alt={`img ${currentIndex + 1}`} />
            <div onClick={() => toggleDeletePhotoModal(currentImage)}>
              <FaTrash style={{ fontSize: "30px" }} className="text-red absolute top-1 right-1 bg-slate-200 rounded-full p-1" />
            </div>
          </section>
          <FaChevronCircleRight style={{ fontSize: "30px" }} className="text-main" onClick={goToNextSlide}/>
        </div>
        <form encType="multipart/form-data">
          <InputImages name="photos" setImages={setImages} accept="image/*" />      
        </form>
      </>
    }
    </div>
  )
}

export default ToggleImages